/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // For Single Product page - Color Variant
      // const wrapper = document.querySelector('#color-title');
      // const defaultValue = wrapper.innerHTML;
      // const colors = document.querySelectorAll('.color');
      // colors.forEach(function(el){
      //   el.addEventListener('mouseover', event => { wrapper.innerHTML = el.getAttribute('title'); })
      //   el.addEventListener('mouseout', event => { wrapper.innerHTML = defaultValue; })
      //   }
      // );

  
  new Pushbar({
    	overlay: true
    });








  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
